import { getStrings } from "../../Common/Localization/commonStrings";

const localizedStrings = {
  PaperlessBilling: {
    strings: {
      en: {
          AlertName:"Paperless Billing",
          AlertHeading:"Paperless Billing benefits include:",
          AlertPoint1:"Email alert when your bill is ready, 19 days before your bill is due.",
          AlertPoint2:"Up to 36 months of bills available online.",
          AlertPoint3:"Secure access to your bill, 24/7, on your computer, tablet, or phone.",
          LearnMore:"Learn more"
              },
            
            
      es: {
      }
    },
    common: ['globalError']
  },
  RepairMaintenanceAlerts: {
    strings: {
      en: {
          AlertName:"Repair and Maintenance Alerts",
          AlertExp:"Stay informed about unplanned repair and planned maintenance outages",
          InfoIconDescription:"Receive status updates for an unplanned ", 
          RepairOutagesText:"repair outage",
          InfoIconDescription2:", including when it started, what caused it, and when power will be restored, as well as a planned ",
          MaintenanceOutagesText:"maintenance outage",
          InfoIconDescription3:", including when it will take place, advance reminders, and updates on scheduling changes.",
        },
            
            
      es: {
      }
    },
    common: ['globalError']
  },
  EmergencyAlerts: {
    strings: {
      en: {
          AlertName:"Emergency Alerts",
          AlertExp:"Stay informed about unplanned repair and planned maintenance outages",
          InfoIconDescription:"Receive status updates approximately 48 hours in advance of a potential ", 
          PSPSeventText:"PSPS event",
          InfoIconDescription2:" called during extreme and potentially dangerous weather conditions, or in the rare instance when the California Independent System Operator (CAISO) declares a statewide Stage 3 Emergency necessitating a ",
          Rotatingoutagetext:"Rotating Outage",
          InfoIconDescription3: " (\"rolling blackout\").",
        },
            
            
      es: {
      }
    },
    common: ['globalError']
  },
  BaAlerts: {
    strings: {
      en: {
          AlertName:"Budget Assistant Notifications",
          AlertExp:"Get early warning of projected high usage charges",
          InfoIconDescription:"A free service that lets you identify a spending goal then alerts you by phone, email or text to tell you how you're doing. Receive alerts weekly, mid-monthly, or when you're projected to exceed your spending goal.",
          LearnMore:"Learn more"
              },
            
            
      es: {
      }
    },
    common: ['globalError']
  },
  CppAlerts: {
    strings: {
      en: {
          AlertName:"Critical Peak Pricing Notifications",
         AlertPara1:"Critical Peak Pricing (CPP) provides four months of summer season bill credits in exchange for higher prices during 12-15 CPP events. When called, CPP events are from 4 p.m. – 9 p.m. on non-holiday weekdays, usually occurring on the hottest summer days. By reducing your electricity use during CPP events, you can minimize the impacts of these higher prices.",

         AlertPara2:"CPP alerts help you plan for CPP events. We will notify you the day before an event via phone, email, or text.",
         LearnMore:"Learn more"
              },
            
            
      es: {
      }
    },
    common: ['globalError']
  },


  CustomerPreference: {
    strings: {
      en: {
          OutageLanguage:'Outage Alert Language',
          OutageLanguageDescription:'Language preference will be expanded to include all alert types in future',
          LanguageLabel:'English',
          ButtonLabel:'Edit'
              },
      es: {
      }
    },
    common: ['globalError']
  },
  CentralizedContainer: {
    strings: {
      en: {
          BannerLabel:'PREFERENCE CENTER',
          BannerSubText:'Decide which notifications to receive',
          CustomerPreferenceLabel:'Customer Preferences',
          AccountPreferenceLabel:'Account Preferences',
              },
      es: {
      }
    },
    common: ['globalError']
  },
  
  
};

export const getLocalizedStrings = (componentName) => {
  app.logger.getLogger().debug("Comp Name" + componentName);
  var strings = getStrings(localizedStrings[componentName].strings,
    localizedStrings[componentName].common,true);
    return strings;
 // return new LocalizedStrings(strings);
};
